import { handleActions } from 'redux-actions';
import {
  dismissSyncWarning,
  setPendingChangesFlag,
  syncRequest,
  syncSuccess,
  syncFailure
} from '../../actions/ui/sync';

export default handleActions(
  {
    [syncRequest]: state => ({ ...state, isRunning: true, lastError: null }),
    [syncSuccess]: state => ({
      ...state,
      isRunning: false,
      hasPendingChanges: false,
      lastError: null
    }),
    [syncFailure]: (state, action) => ({
      ...state,
      isRunning: false,
      lastError:
        action.payload == null
          ? null
          : typeof action.payload === 'object' && action.payload.message
            ? action.payload.message
            : String(action.payload)
    }),
    [dismissSyncWarning]: state => ({ ...state, isWarningVisible: false }),
    [setPendingChangesFlag]: state => ({ ...state, hasPendingChanges: true })
  },
  {
    isRunning: false,
    isWarningVisible: true,
    hasPendingChanges: false,
    lastError: null
  }
);
